import { createSelector } from '@ngrx/store';
import { notEmptyNullUndefined } from 'src/app/helpers/utils';
import { User } from 'src/app/models/data/user.model';
import { selectUserState } from 'src/app/store/root.selectors';
import * as fromUser from '../reducers/user.reducer';

export const selectUser = createSelector(
  selectUserState,
  (state: fromUser.State): User => state.user
)

export const selectOmisUser = createSelector(
  selectUserState,
  state => state.omisUser
)

export const selectTimeslotBookingUser = createSelector(
  selectUserState,
  state => state.timeslotBookingUser
)

export const selectUserSignInStatus = createSelector(
  selectUserState,
  (state: fromUser.State): boolean => notEmptyNullUndefined(state.user)
)

export const selectUserCredentials = createSelector(
  selectUserState,
  (state: fromUser.State) => state.credentials
)

export const selectUserSnapshot = createSelector(
  selectUserState,
  (state: fromUser.State): User => state.userSnapshot
)

export const selectUIUserFailLogin = createSelector(
  selectUserState,
  state => state.uiloginFail
)

export const selectLocation = createSelector(
  selectUserState,
  state => state.userLocation
)

export const selectCustomerVisit = createSelector(
  selectUserState,
  state => state.customerVisit
)

export const selectAllUsers = createSelector(
  selectUserState,
  state => state.user
)

export const selectUserAuth = createSelector(
  selectUserState,
  state => state.userAuth
)

export const selectLoginLoading = createSelector(
  selectUserState,
  state => state.loginLoading
)
